import { HostBinding, Directive } from '@angular/core';

@Directive()
export class BaseComponent {
  @HostBinding('class.sd-component') sdComponent = true;
}
